import { render, staticRenderFns } from "./IconChild.vue?vue&type=template&id=e9a95c86&"
import script from "./IconChild.vue?vue&type=script&lang=ts&"
export * from "./IconChild.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports